var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-video-block',{attrs:{"alt":_vm.alt,"video-url":_vm.videoUrl,"caption":_vm.caption}})}
var staticRenderFns = []

export { render, staticRenderFns }